var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareIcon1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 383.25 383.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,38.92C1.57,21.81,21.75,0,39.3,0h137.36v29.94H42.29c-5.75,0-12.97,8.67-12.38,14.57v294.23c.33,8.16,6.44,14.27,14.6,14.6h294.23c5.9.6,14.57-6.62,14.57-12.38v-134.36h29.94v137.36c0,18-21.82,37.25-38.92,39.3H38.92c-20.37-3.74-35.19-18.6-38.92-38.92V38.92Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "383.25 0 383.25 149.71 353.31 149.71 353.31 51.65 112.65 291.92 91.67 270.97 331.6 29.94 233.54 29.94 233.54 0 383.25 0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon1);
export default __webpack_public_path__ + "static/media/Share Icon_1.c92bf5cee9f5f02b7df3d19d2b6014b8.svg";
export { ForwardRef as ReactComponent };